<template>
	<div v-if="!isEmpty(company)" class="d-flex">
		<span class="navbar-text d-none d-sm-block">
			<strong>{{ company.name }}</strong>
		</span>
		<!-- <span class="navbar-text d-none d-sm-block ml-2">
			Account ID: <strong>{{ company.external_client_id }}</strong>
		</span> -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters({
			company: 'company',
		}),
	},
	props: ['type'],
};
</script>
